export const modules = {
  toolbar: [['bold', 'italic'], ['link'], [{ list: 'bullet' }]],
  clipboard: { matchVisual: false },
}

export const formats = ['bold', 'italic', 'link', 'list', 'bullet']
